import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=7678a830&scoped=true&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/Footer.css?vue&type=style&index=0&id=7678a830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678a830",
  null
  
)

export default component.exports